import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, BookOpenIcon, AlertTriangleIcon, MessageCircleIcon, HeartIcon } from 'lucide-react';
export function PremiumBonuses() {
  const bonuses = [{
    icon: CheckCircleIcon,
    title: 'Bono 1: Checklist de hábitos íntimos saludables',
    description: 'Una lista práctica para identificar qué estás haciendo bien y qué pequeños cambios pueden marcar una gran diferencia en tu cuidado diario.'
  }, {
    icon: BookOpenIcon,
    title: 'Bono 2: Diario de síntomas',
    description: 'Una plantilla para registrar episodios, identificar patrones y tener información organizada lista para tu próxima consulta médica.'
  }, {
    icon: AlertTriangleIcon,
    title: 'Bono 3: Lista de señales de alerta',
    description: 'Saber cuándo algo requiere atención médica urgente puede ahorrarte complicaciones. Esta lista te lo dice de forma clara y directa.'
  }, {
    icon: MessageCircleIcon,
    title: 'Bono 4: Preguntas para la consulta médica',
    description: 'Las preguntas exactas que deberías hacerle a tu médico para aprovechar al máximo tu consulta y no salir con más dudas de las que entraste.'
  }, {
    icon: HeartIcon,
    title: 'Bono 5: Plan de bienestar íntimo de 7 días',
    description: 'Un plan diario, simple y realista para empezar a cuidar tu salud íntima desde hoy, sin complicaciones ni cambios extremos.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-193">
      <div className="max-w-6xl mx-auto" data-id="element-194">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-4 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-195">
          🎁 Bonos premium incluidos
        </motion.h2>

        <motion.p className="text-xl text-body mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-196">
          Todo esto viene incluido sin costo adicional
        </motion.p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-197">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.div key={index} className="bg-accent-blush p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-198">
                <Icon className="w-10 h-10 text-heading mb-4" data-id="element-199" />
                <h3 className="font-heading text-xl font-bold text-heading mb-3" data-id="element-200">
                  {bonus.title}
                </h3>
                <p className="text-body leading-relaxed" data-id="element-201">{bonus.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}